export default __webpack_public_path__ + "static/media/rust.11bdf0d3.svg";